import { Component, Event, EventEmitter, Listen } from "@stencil/core";
import { getCarts } from "@stores/cart.store";
import { CartUpdatedEventDetails } from "../f-cart-flyout-model";

@Component({
  tag: "tt-cart-proxy",
})
export class TtCartProxy {
  @Event() cartUpdated: EventEmitter<CartUpdatedEventDetails>;
  @Listen("onCartChange", { target: "window" })
  onCartChangeHandler(event: CustomEvent) {
    getCarts().then(() => {
      this.cartUpdated.emit({ cartCode: event.detail });
    });
  }
}
